(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/day-time-limit/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/accountservices/day-time-limit/assets/javascripts/init.js');
"use strict";

svs.accountservices.day_time_limit.start();

 })(window);